import { SprinklesElement } from "sprinkles-js";

export default class FilterOptionsElement extends SprinklesElement {
  static tagName = "filter-options";
  static refs = ["input"];
  static events = {
    input: { method: "filter", ref: "input" },
    keydown: { method: "preventEnterSubmit", ref: "input" },
  };

  afterConnected() {
    this.options = [
      ...this.querySelectorAll("[data-filter-options-ref=option]"),
    ];
  }

  filter(event) {
    const value = event.target.value.toLowerCase();
    this.options.forEach((option) => {
      option.hidden = !(
        option.textContent.toLowerCase().includes(value) ||
        option.dataset.value?.toLowerCase()?.includes(value)
      );
    });
  }

  preventEnterSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }
}
